import PropTypes from 'prop-types';
import { createRef } from 'react';
import { connect } from 'react-redux';

import { CONFIRMATION_REQUIRED } from 'Component/MyAccountCreateAccount/MyAccountCreateAccount.config';
// import { ORDER_ID } from 'Component/MyAccountOrder/MyAccountOrder.config';
import { STATE_CONFIRM_EMAIL } from 'Component/MyAccountOverlay/MyAccountOverlay.config';
import CheckEmailQuery from 'Query/CheckEmail.query';
import MyAccountQuery from 'Query/MyAccount.query';
import { CHECKOUT_CUSTOMER_CREATE_URL, CHECKOUT_CUSTOMER_URL, CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import {
    ACCOUNT_EMPLOYEE_REGISTRATION_URL, ACCOUNT_PRO_LOGIN_URL,
    ACCOUNT_PRO_REGISTRATION_URL,
    ACCOUNT_REGISTRATION_URL, ACCOUNT_STUDENT_LOGIN_URL,
    ACCOUNT_STUDENT_REGISTRATION_URL, CUSTOMER_GROUP_LABELS, GROUP_ID_PRO, GROUP_ID_STUDENT
} from 'Route/MyAccount/MyAccount.config';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    MyAccountCreateAccountContainer as SourceMyAccountCreateAccountContainer
} from 'SourceComponent/MyAccountCreateAccount/MyAccountCreateAccount.container';
import { CustomerFormValuesType, CustomerType } from 'Type/Account.type';
import { ProFieldsType } from 'Type/Config.type';
import { MatchType } from 'Type/Router.type';
import { isSignedIn } from 'Util/Auth';
import { scrollToTop } from 'Util/Browser';
import BrowserDatabase from 'Util/BrowserDatabase';
import getFieldsData from 'Util/Form/Extract';
import transformToNameValuePair from 'Util/Form/Transform';
import history from 'Util/History';
import { fetchMutation } from 'Util/Request';
import { fetchQuery } from 'Util/Request/Query';
import { appendWithStoreCode } from 'Util/Url';
import { validatePhoneNumber } from 'Util/Validator';
import { VALIDATION_MESSAGES } from 'Util/Validator/Config';

import {
    COMPANY_SEARCH_STEP,
    COMPANY_STEP,
    CREATE_ACCOUNT_DATA,
    CREATE_ACCOUNT_DATA_DURATION,
    CUSTOMER_STEP,
    CUSTOMER_TYPES,
    FILE_KEY_EMPLOYEE_ID,
    FILE_KEY_PRO_ID, FILE_KEY_STUDENT_ID,
    OPTIN_STEP,
    RECAP_STEP,
    UPLOAD_STEP
} from './MyAccountCreateAccount.config';

/** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    currentStoreCode: state.ConfigReducer.code,
    defaultCountry: state.ConfigReducer.default_country,
    isCustomerTypeEmployeeEnabled: state.ConfigReducer.employees_active,
    isCustomerTypeStudentEnabled: state.ConfigReducer.students_active,
    isCompanySearchEnabled: state.ConfigReducer.api_societe_com,
    isSiretEnabled: state.ConfigReducer.siret_active,
    isAttestationAvsEnabled: state.ConfigReducer.attestation_avs_active,
    customer: state.MyAccountReducer.customer,
    proFieldsByCountry: state.ConfigReducer.pro_fields_by_country
});

/** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // ...
});

/** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container */
export class MyAccountCreateAccountContainer extends SourceMyAccountCreateAccountContainer {
    static propTypes = {
        ...SourceMyAccountCreateAccountContainer.propTypes,
        match: MatchType.isRequired,
        currentStoreCode: PropTypes.string,
        defaultCountry: PropTypes.string,
        isCustomerTypeStudentEnabled: PropTypes.bool.isRequired,
        isCustomerTypeEmployeeEnabled: PropTypes.bool.isRequired,
        isCompanySearchEnabled: PropTypes.bool.isRequired,
        isSiretEnabled: PropTypes.bool.isRequired,
        isAttestationAvsEnabled: PropTypes.bool.isRequired,
        customerType: PropTypes.string,
        defaultValues: CustomerFormValuesType,
        isCheckoutSuccess: PropTypes.bool,
        customer: CustomerType.isRequired,
        proFieldsByCountry: ProFieldsType
    };

    static defaultProps = {
        ...SourceMyAccountCreateAccountContainer.defaultProps,
        currentStoreCode: 'fr-FR',
        defaultCountry: 'FR',
        customerType: null,
        defaultValues: {},
        isCheckoutSuccess: false,
        proFieldsByCountry: []
    };

    formRef = createRef();

    containerFunctions = {
        ...this.containerFunctions,
        onCustomerTypeChanged: this.onCustomerTypeChanged.bind(this),
        onPhoneNumberChange: this.onPhoneNumberChange.bind(this),
        goToCompanyStep: this.goToCompanyStep.bind(this),
        onSubmitCompanySearchForm: this.onSubmitCompanySearchForm.bind(this),
        onSubmitCompanyForm: this.onSubmitCompanyForm.bind(this),
        onSkipConfirmIdForm: this.onSkipConfirmIdForm.bind(this),
        onSubmitConfirmIdForm: this.onSubmitConfirmIdForm.bind(this),
        onRecapButtonClick: this.onRecapButtonClick.bind(this),
        onStoreSwitcherBeforeRedirect: this.onStoreSwitcherBeforeRedirect.bind(this)
    };

    static navigateToSelectedStep(props, state) {
        const { match } = props;
        const { params: { accountStep: urlStep = '', uploadStep: urlUploadStep = '' } = {} } = { ...match };

        if (urlStep === UPLOAD_STEP) {
            const uploadStepList = MyAccountCreateAccountContainer.getUploadStepList(props, state);
            const currentUploadStep = uploadStepList.find((step) => step.url === urlUploadStep) || {};

            return {
                createAccountStep: urlStep,
                currentUploadStep
            };
        }

        if ([
            CUSTOMER_STEP,
            COMPANY_SEARCH_STEP,
            COMPANY_STEP,
            OPTIN_STEP,
            RECAP_STEP
        ].includes(urlStep)) {
            return {
                createAccountStep: urlStep,
                currentUploadStep: {}
            };
        }

        return {
            createAccountStep: CUSTOMER_STEP,
            currentUploadStep: {}
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { defaultValues, customerData } = state;

        return {
            ...MyAccountCreateAccountContainer.navigateToSelectedStep(props, state),
            defaultValues: {
                ...defaultValues,
                ...customerData
            }
        };
    }

    __construct(props) {
        const { customerType: customerTypeFromProps, defaultValues } = props;

        const { location: { state = {} } } = history;

        const cookieValues = BrowserDatabase.getItem(CREATE_ACCOUNT_DATA) || {};

        const loggedCustomerValues = this.getCustomerData();

        // defaultValues => come from checkout success page
        // state => come from checkout success page (OLD ?)
        // cookieValues => come from redirect caused by store switcher
        // loggedCustomerValues => come from logged in user who wants to go pro or student
        const mergedDefaultValues = {
            ...defaultValues, ...state, ...cookieValues, ...loggedCustomerValues
        };

        const customerType = customerTypeFromProps || CUSTOMER_TYPES.private;

        this.state = {
            customerType,
            isCustomerTypeFieldHidden: false, // !!customerType
            customerData: {},
            currentUploadStep: {},
            ...MyAccountCreateAccountContainer.navigateToSelectedStep(this.props, { customerType }),
            companyDetails: {},
            phoneNumber: '',
            phoneNumberError: '',
            hasMissingDocuments: false,
            defaultValues: mergedDefaultValues,
            registerAgreements: [],
            isLoadingAgreements: false,
            uploadStepList: []
        };
    }

    /**
     * If telephone is set (when a logged in user wants a pro account), we need to manually trigger the phone input
     * to check its format (otherwise, an error is thrown at submit because the state in not set, anc we cannot set it
     * manually because the number need the formatting of the phone-input component)
     */
    componentDidMount() {
        const { defaultValues } = this.state;

        if (defaultValues.telephone !== '') {
            const input = document.querySelector('input[name="telephone"]');
            if (input) {
                const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
                nativeInputValueSetter.call(input, defaultValues.telephone);
                const ev = new Event('input', { bubbles: true });
                input.dispatchEvent(ev);
            }
        }

        this.setUploadStepList();

        this.handleRedirectIfMissingFields();
    }

    componentDidUpdate(prevProps, prevState) {
        const { createAccountStep, customerType } = this.state;
        const { createAccountStep: prevCreateAccountStep } = prevState;
        const { proFieldsByCountry } = this.props;
        const { proFieldsByCountry: prevProFieldsByCountry } = prevProps;

        this.handleRedirectIfMissingFields();

        if (createAccountStep !== prevCreateAccountStep) {
            scrollToTop();

            if (createAccountStep === OPTIN_STEP && customerType === CUSTOMER_TYPES.pro) {
                this.getRegisterAgreements();
            }
        }

        if (proFieldsByCountry !== prevProFieldsByCountry) {
            this.setUploadStepList();
        }
    }

    static getUploadStepList(props, state) {
        const { proFieldsByCountry } = props;
        const { customerType } = state;

        const identityStep = {
            url: '',
            title: __('Validate your identity').toString(),
            strings: {}
        };

        if (customerType === CUSTOMER_TYPES.pro) {
            identityStep.code = FILE_KEY_PRO_ID;
            identityStep.strings = {
                description: __('Votre pièce d\'identité est nécessaire à la validation de votre compte professionnel.'),
                uploadDescription: __('Justificatifs acceptés : carte d\'identité, passeport, permis de conduire, permis de séjour'),
                skipLabel: __('Je transmets ma pièce d\'identité plus tard')
            };
        } else if (customerType === CUSTOMER_TYPES.employee) {
            identityStep.code = FILE_KEY_EMPLOYEE_ID;
            identityStep.strings = {
                description: __('Votre dernière fiche de paie est nécessaire à la validation de votre compte salarié.'),
                uploadDescription: __('Les délais d\'ouverture de compte salarié seront plus longs. En l\'absence des justificatifs, vous posséderez un compte client particulier et ne pourrez pas bénéficier des avantages professionnels.'),
                skipLabel: __('Je transmets mon justificatif plus tard')
            };
        } else {
            identityStep.code = FILE_KEY_STUDENT_ID;
            identityStep.strings = {
                description: __('Votre certificat de scolarité est nécessaire à la validation de votre compte étudiant.'),
                uploadDescription: __('Justificatifs acceptés : certificat de scolarité du secteur de l\'esthétique, de la beauté, de la coiffure ou des cosmétiques'),
                skipLabel: __('Je transmets mon justificatif plus tard')
            };
        }

        // This first step is always present
        const uploadStepList = [identityStep];

        // For pro only, check other fields
        if (customerType === CUSTOMER_TYPES.pro) {
            const fileFields = proFieldsByCountry.filter((field) => field.type === 'file' && Boolean(field.active));
            fileFields.forEach((field) => {
                uploadStepList.push({
                    code: field.code,
                    title: field.label,
                    url: field.code,
                    strings: {}
                });
            });
        }

        if (customerType === CUSTOMER_TYPES.employee) {
            // For employee only, add more verify CNI step
            uploadStepList.push({
                code: FILE_KEY_PRO_ID,
                title: __('Validate your identity'),
                url: FILE_KEY_PRO_ID,
                strings: {
                    description: __('Votre pièce d\'identité est nécessaire à la validation de votre compte salarié.'),
                    uploadDescription: __('Justificatifs acceptés : carte d\'identité, passeport, permis de conduire, permis de séjour'),
                    skipLabel: __('Je transmets mon justificatif plus tard')
                }
            });
        }

        return uploadStepList;
    }

    setUploadStepList() {
        const uploadStepList = MyAccountCreateAccountContainer.getUploadStepList(this.props, this.state);

        this.setState({ uploadStepList });
    }

    findNextUploadStep() {
        const { uploadStepList, currentUploadStep: { code } } = this.state;

        const currentUploadStepIndex = uploadStepList.findIndex((step) => step.code === code);

        if (currentUploadStepIndex === -1 || currentUploadStepIndex === uploadStepList.length - 1) {
            return null;
        }

        return uploadStepList[currentUploadStepIndex + 1];
    }

    getStepList() {
        const { isCompanySearchEnabled, proFieldsByCountry, defaultCountry } = this.props;
        const { customerType } = this.state;

        switch (customerType) {
        case CUSTOMER_TYPES.employee:
            return [
                {
                    key: CUSTOMER_STEP,
                    enable: true
                },
                {
                    key: UPLOAD_STEP,
                    enable: true,
                    requiredFields: [[
                        'email',
                        'firstname',
                        'lastname',
                        'password'
                    ]]
                },
                {
                    key: OPTIN_STEP,
                    enable: true
                },
                {
                    key: RECAP_STEP,
                    enable: true/* ,
                    requiredFields: [[
                        'privacy_checkbox'
                    ]] */
                }
            ];
        case CUSTOMER_TYPES.student:
            return [
                {
                    key: CUSTOMER_STEP,
                    enable: true
                },
                {
                    key: UPLOAD_STEP,
                    enable: true,
                    requiredFields: [[
                        'email',
                        'firstname',
                        'lastname',
                        'password'
                    ]]
                },
                {
                    key: OPTIN_STEP,
                    enable: true
                },
                {
                    key: RECAP_STEP,
                    enable: true/* ,
                    requiredFields: [[
                        'privacy_checkbox'
                    ]] */
                }
            ];
        case CUSTOMER_TYPES.pro:
            const mandatoryProFields = proFieldsByCountry.filter(
                (field) => field.type !== 'file' && Boolean(field.active) && Boolean(field.obligatoire)
            );

            const companyFormRequiredFields = [
                'societe',
                'street',
                'postcode',
                'city',
                ...mandatoryProFields.map((field) => field.code)
            ];

            const companyFormRequiredFieldsScenarii = [
                companyFormRequiredFields
            ];

            if (defaultCountry === 'FR') {
                const companyFormRequiredFieldsCopy = Array.from(companyFormRequiredFields);
                const siretIndex = companyFormRequiredFieldsCopy.indexOf('siret');
                if (siretIndex > -1) {
                    companyFormRequiredFieldsCopy.splice(siretIndex, 1);
                    companyFormRequiredFieldsCopy.push('siret_comment');
                    companyFormRequiredFieldsScenarii.push(companyFormRequiredFieldsCopy);
                }
            }

            return [
                {
                    key: CUSTOMER_STEP,
                    enable: true
                },
                {
                    key: COMPANY_SEARCH_STEP,
                    enable: isCompanySearchEnabled,
                    requiredFields: [[
                        'email',
                        'firstname',
                        'lastname',
                        'password',
                        'telephone'
                    ]]
                },
                {
                    key: COMPANY_STEP,
                    enable: true,
                    requiredFields: [[
                        'email',
                        'firstname',
                        'lastname',
                        'password',
                        'telephone'
                    ]]
                },
                {
                    key: UPLOAD_STEP,
                    enable: true,
                    requiredFields: companyFormRequiredFieldsScenarii
                    /* [
                        [
                            'societe',
                            'siret',
                            'street',
                            'postcode',
                            'city'
                        ],
                        [
                            'societe',
                            'siret_comment',
                            'street',
                            'postcode',
                            'city'
                        ]
                    ] */
                },
                {
                    key: OPTIN_STEP,
                    enable: true
                },
                {
                    key: RECAP_STEP,
                    enable: true/* ,
                    requiredFields: [[
                        'privacy_checkbox'
                    ]] */
                }
            ];
        default:
            return [
                {
                    key: CUSTOMER_STEP,
                    enable: true
                }
            ];
        }
    }

    /* eslint-disable no-continue, fp/no-let */
    getAccessibleStep(currentStep, customerData) {
        const stepList = this.getStepList();

        const stepIndex = stepList.findIndex((step) => step.key === currentStep);

        const populatedFields = Object.keys(customerData); // this object should not contains empty values...

        let validStep = '';

        for (let i = 0; i <= stepIndex; i++) {
            const step = stepList[i];

            // Skip disabled steps
            if (!step.enable) {
                continue;
            }

            // Step is valid if it doesn't have required fields
            if (!step.requiredFields || !step.requiredFields.length) {
                validStep = step.key;
                continue;
            }

            // requiredFields is an array of arrays (to handle different configurations of fields)
            const { requiredFields } = step;

            const hasRequiredFields = requiredFields.some(
                (fieldList) => fieldList.every((field) => {
                    // B2C to PRO/ETU => do not check email nor password (already set)
                    if (isSignedIn() && ['email', 'password'].includes(field)) {
                        return true;
                    }

                    return populatedFields.includes(field);
                })
            );

            if (hasRequiredFields) {
                validStep = step.key;
            } else {
                break;
            }
        }

        return validStep;
    }
    /* eslint-enable no-continue, fp/no-let */

    isValidStep(currentStep) {
        const stepList = this.getStepList();
        return stepList.find((step) => step.key === currentStep && step.enable);
    }

    handleRedirectIfMissingFields() {
        const { match } = this.props;
        const { params: { accountStep: urlStep = '' } = {} } = { ...match };
        const { createAccountStep, customerData } = this.state;

        // If step is not in the list, go to first step
        if (!this.isValidStep(createAccountStep)) {
            this.goToStep(CUSTOMER_STEP, true);
        }

        // If success step but account is not created, redirect
        if (createAccountStep === RECAP_STEP && !isSignedIn()) {
            this.goToStep(CUSTOMER_STEP, true);
        }

        // const requiredFields = this.getStepRequiredFieldsList(createAccountStep);
        const accessibleStep = this.getAccessibleStep(createAccountStep, customerData);

        // If we are missing required fields to access current step, redirect
        if (createAccountStep !== accessibleStep) {
            this.goToStep(accessibleStep, true);
        }

        // If the url doesn't match the step, change the url
        if (urlStep && urlStep !== createAccountStep) {
            this.goToStep(createAccountStep, true);
        }
    }

    /**
     * @returns boolean
     */
    isInCheckout() {
        const { location: { pathname } } = history;

        return pathname.includes(CHECKOUT_URL);
    }

    getCustomerData() {
        if (!isSignedIn()) {
            return {};
        }

        const {
            customer: {
                addresses = [],
                firstname = '',
                lastname = '',
                email = ''
            } = {}
        } = this.props;

        return {
            firstname,
            lastname,
            email,
            telephone: addresses.find((address) => address.default_billing === true)?.telephone || ''
        };
    }

    /**
     * Override
     * @returns {{formRef: React.RefObject<unknown>, customerType}}
     */
    containerProps() {
        const {
            currentStoreCode,
            isCustomerTypeEmployeeEnabled,
            isCustomerTypeStudentEnabled,
            isSiretEnabled,
            isCheckoutSuccess,
            customer
        } = this.props;
        const {
            customerType,
            isCustomerTypeFieldHidden,
            createAccountStep,
            companyDetails,
            phoneNumberError,
            hasMissingDocuments,
            defaultValues,
            registerAgreements,
            isLoadingAgreements,
            uploadStepList,
            currentUploadStep
        } = this.state;

        return {
            ...super.containerProps(),
            formRef: this.formRef,
            currentStoreCode,
            isCustomerTypeEmployeeEnabled,
            isCustomerTypeStudentEnabled,
            isSiretEnabled,
            isCheckoutSuccess,
            customer,
            customerType,
            isCustomerTypeFieldHidden,
            createAccountStep,
            companyDetails,
            phoneNumberError,
            hasMissingDocuments,
            defaultValues,
            registerAgreements,
            isLoadingAgreements,
            uploadStepList,
            currentUploadStep
        };
    }

    onCustomerTypeChanged() {
        const { current } = this.formRef;

        if (!current) {
            return;
        }

        const values = getFieldsData(current.formRef, true);

        const customerType = values.find((value) => value.name === 'customer_type')?.value;

        if (customerType) {
            this.setState({ customerType });

            if (this.isInCheckout()) {
                document.querySelector('main.Checkout').setAttribute(
                    'data-customer-type',
                    Object.entries(CUSTOMER_TYPES).find(([_key, value]) => value === customerType)[0]
                );
            } else {
                const state = {
                    email: values.find((field) => field.name === 'email')?.value || '',
                    password: values.find((field) => field.name === 'password')?.value || '',
                    firstname: values.find((field) => field.name === 'firstname')?.value || '',
                    lastname: values.find((field) => field.name === 'lastname')?.value || ''
                };

                history.replace({ pathname: appendWithStoreCode(this.getRegistrationUrl(customerType)), state });
            }
        }
    }

    onPhoneNumberChange(value, country, _e, formattedValue) {
        const result = validatePhoneNumber(value, country);

        this.setState({
            phoneNumber: formattedValue,
            phoneNumberError: result !== true ? result : ''
        });
    }

    /**
     * Override: disable notification, check phone number
     */
    onError() {
        // const { showNotification } = this.props;
        // showNotification('info', __('Incorrect data! Please resolve all field validation errors.'));

        const { customerType, phoneNumber } = this.state;

        if ([CUSTOMER_TYPES.pro/* , CUSTOMER_TYPES.student */].includes(customerType) && phoneNumber === '') {
            this.setState({ phoneNumberError: VALIDATION_MESSAGES.isRequired });
        }
    }

    /**
     * @param customerType {string} type of account (from checkbox value)
     * @param customerGroupId {number} group id associated with existing email
     */
    showNotificationEmailAlreadyExists(customerType, customerGroupId) {
        const { showNotification } = this.props;

        const accountLoginUrl = (customerType === CUSTOMER_TYPES.pro || customerType === CUSTOMER_TYPES.employee) ? ACCOUNT_PRO_LOGIN_URL : ACCOUNT_STUDENT_LOGIN_URL;
        const selectedGroupId = (customerType === CUSTOMER_TYPES.pro || customerType === CUSTOMER_TYPES.employee) ? GROUP_ID_PRO : GROUP_ID_STUDENT;

        const isInCheckout = this.isInCheckout();

        const loginPageUrl = isInCheckout
            ? appendWithStoreCode(CHECKOUT_CUSTOMER_URL)
            : appendWithStoreCode(accountLoginUrl);

        const groupLabel = CUSTOMER_GROUP_LABELS[selectedGroupId]?.singular.toLowerCase() || '';

        // eslint-disable-next-line fp/no-let
        let message = '';
        if (!isInCheckout) {
            message = customerGroupId === selectedGroupId
                ? __('Vous bénéficiez déjà d\'un compte %s :', groupLabel)
                : `${__('Cet email appartient déjà à un compte.')}<br />${__('Pour faire une demande de compte %s, veuillez vous connecter :', groupLabel)}`;
        } else {
            message = customerGroupId === selectedGroupId
                ? __('Cet email appartient déjà à un compte %s.', groupLabel)
                : __('Cet email appartient déjà à un compte.');
        }

        showNotification(
            'error',
            `${message} <a href="${loginPageUrl}">${__('Me connecter')}</a>`
        );
    }

    async onSuccess(form, fields) {
        const {
            createAccount,
            onSignIn,
            setSignInState,
            setLoadingState,
            isLoading,
            isLandingPage,
            showNotification,
            isMobile,
            isCompanySearchEnabled,
            defaultValues: {
                lastGuestOrder
            }
        } = this.props;
        const {
            customerType,
            customerData: savedCustomerData,
            phoneNumber,
            phoneNumberError
        } = this.state;

        if (isLoading) {
            return;
        }

        if ([CUSTOMER_TYPES.pro/* , CUSTOMER_TYPES.student */].includes(customerType) && phoneNumber === '') {
            this.setState({ phoneNumberError: VALIDATION_MESSAGES.isRequired });
            return;
        }

        if (phoneNumberError !== '') {
            return;
        }

        // eslint-disable-next-line fp/no-let
        let formattedCustomerData = {};

        const {
            password,
            email,
            firstname,
            lastname,
            // is_subscribed,
            // taxvat,
            telephone,
            rgpd_offre_peggysage,
            rgpd_offre_peggysage_sms,
            // rgpd_offre_partenaire,
            // rgpd_offre_partenaire_sms,
            privacy_checkbox
        } = transformToNameValuePair(fields);

        /* const customerData = {
            customer: {
                firstname,
                lastname,
                email,
                is_subscribed,
                taxvat
            },
            password
        }; */
        const customerData = {
            firstname,
            lastname
        };

        // Only add email and password for new accounts (not for transformation of accounts to pro or students)
        if (!isSignedIn()) {
            customerData.password = password;
            customerData.email = email;
        }

        const optinData = {
            is_subscribed: rgpd_offre_peggysage,
            rgpd_offre_peggysage,
            rgpd_offre_peggysage_sms
            // rgpd_offre_partenaire,
            // rgpd_offre_partenaire_sms
        };

        // Only add privacy check for new accounts
        if (!isSignedIn()) {
            optinData.privacyConsentSelection = [
                {
                    code: 'privacy_checkbox',
                    accept: privacy_checkbox
                }
            ];
        }

        // Field set at first step
        const customerTypeField = fields.find((field) => field.name === 'customer_type' && field.value)?.value;

        // First step for pro account
        if (customerTypeField === CUSTOMER_TYPES.pro) {
            customerData.customerType = customerTypeField;
            customerData.telephone = telephone;

            if (isSignedIn()) {
                // Transformation of a private account to a pro one => go directly to next step
                this.setState({
                    customerData
                }, () => this.goToStep(isCompanySearchEnabled ? COMPANY_SEARCH_STEP : COMPANY_STEP));

                return;
            }

            // New account => check if email already exists

            setLoadingState(true);

            fetchQuery(CheckEmailQuery.getIsEmailAvailableQuery(email)).then(
                /** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container/MyAccountCreateAccountContainer/onSuccess/then/catch/fetchQuery/then */
                ({ isEmailAvailable: { is_email_available, customer_group_id = 0 } }) => {
                    if (is_email_available) {
                        this.setState({
                            customerData
                        }, () => this.goToStep(isCompanySearchEnabled ? COMPANY_SEARCH_STEP : COMPANY_STEP));
                    } else {
                        this.showNotificationEmailAlreadyExists(customerTypeField, customer_group_id);
                    }

                    setLoadingState(false);
                }
            ).catch(
                /** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container/MyAccountCreateAccountContainer/onSuccess/then/catch */
                (err) => {
                    const { message } = Array.isArray(err) ? err[0] : err;

                    showNotification('error', message || __('An error occured.'));

                    setLoadingState(false);
                }
            );

            return;
        }

        // First step for student account
        if (customerTypeField === CUSTOMER_TYPES.student || customerTypeField === CUSTOMER_TYPES.employee) {
            customerData.customerType = customerTypeField;
            // customerData.telephone = telephone;

            if (isSignedIn()) {
                // Transformation of a private account to a student one => go directly to next step
                this.setState({
                    customerData
                }, () => this.goToStep(UPLOAD_STEP));

                return;
            }

            // New account => check if email already exists

            setLoadingState(true);

            fetchQuery(CheckEmailQuery.getIsEmailAvailableQuery(email)).then(
                /** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container/MyAccountCreateAccountContainer/onSuccess/then/catch/fetchQuery/then */
                ({ isEmailAvailable: { is_email_available, customer_group_id = 0 } }) => {
                    if (is_email_available) {
                        this.setState({
                            customerData
                        }, () => this.goToStep(UPLOAD_STEP));
                    } else {
                        this.showNotificationEmailAlreadyExists(customerTypeField, customer_group_id);
                    }

                    setLoadingState(false);
                }
            ).catch(
                /** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container/MyAccountCreateAccountContainer/onSuccess/then/catch */
                (err) => {
                    const { message } = Array.isArray(err) ? err[0] : err;

                    showNotification('error', message || __('An error occured.'));

                    setLoadingState(false);
                }
            );

            return;
        }

        // Last step pro & student account
        if ([CUSTOMER_TYPES.pro, CUSTOMER_TYPES.student, CUSTOMER_TYPES.employee].includes(savedCustomerData.customerType)) {
            const compiledCustomerData = { ...savedCustomerData, ...optinData };

            const {
                street,
                postcode,
                city,
                telephone,
                customerType,
                ...compiledCustomerDataInput
            } = compiledCustomerData;

            formattedCustomerData = {
                input: compiledCustomerDataInput,
                customerType
            };

            // Add address for pro account
            if (savedCustomerData.customerType === CUSTOMER_TYPES.pro) {
                formattedCustomerData.addressInput = {
                    firstname: compiledCustomerData.firstname,
                    lastname: compiledCustomerData.lastname,
                    company: compiledCustomerData.societe,
                    street,
                    postcode,
                    city,
                    telephone
                };
            }
        }

        // First and only step for standard account
        if (customerTypeField === CUSTOMER_TYPES.private) {
            const compiledCustomerData = {
                ...customerData,
                ...optinData
            };

            if (lastGuestOrder?.id) {
                compiledCustomerData.last_guest_order = lastGuestOrder;
            }

            /* const lastGuestOrderId = sessionStorage.getItem(ORDER_ID);
            if (lastGuestOrderId) {
                compiledCustomerData.last_guest_order = {
                    increment_id: lastGuestOrderId,
                    protect_code: ''
                };
            } */

            formattedCustomerData = { input: compiledCustomerData };
        }

        // console.log('formattedCustomerData', formattedCustomerData);

        /* if (!formattedCustomerData.uncomment_to_block_creation) {
            return;
        } */

        // Action
        if (formattedCustomerData.input) {
            setLoadingState(true);

            if (isSignedIn()) {
                // Transformation of account => update customer

                const mutation = MyAccountQuery.getUpdateInformationMutation(formattedCustomerData);

                try {
                    await fetchMutation(mutation);

                    this.goToStep(RECAP_STEP);
                } catch (e) {
                    showNotification('error', __('We are experiencing issues, please try again later'));
                } finally {
                    setLoadingState(false);
                }

                return;
            }

            try {
                const code = await createAccount(formattedCustomerData).catch(
                    /** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container/MyAccountCreateAccountContainer/onSuccess/code/createAccount/catch */
                    () => process.exit(1)
                );

                // if user needs confirmation
                if (code === CONFIRMATION_REQUIRED) {
                    setSignInState(STATE_CONFIRM_EMAIL);

                    if (isLandingPage || isMobile) {
                        showNotification(
                            'success',
                            // eslint-disable-next-line max-len
                            __('The email confirmation link has been sent to your email. Please confirm your account to proceed.')
                        );
                    }
                } else if (code !== false) {
                    if ([CUSTOMER_TYPES.pro, CUSTOMER_TYPES.student, CUSTOMER_TYPES.employee].includes(savedCustomerData.customerType)) {
                        this.goToStep(RECAP_STEP);
                    } else {
                        onSignIn();
                    }
                }
            } finally {
                setLoadingState(false);
            }
        }
    }

    async getRegisterAgreements() {
        this.setState({ isLoadingAgreements: true });

        fetchQuery(MyAccountQuery.getRegisterAgreements()).then(
            /** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container/MyAccountCreateAccountContainer/getRegisterAgreements/then/catch/fetchQuery/then */
            (res) => {
                this.setState({
                    registerAgreements: res.getRegisterAgreements || [],
                    isLoadingAgreements: false
                });
            }
        ).catch(
            /** @namespace PeggysagePwa/Component/MyAccountCreateAccount/Container/MyAccountCreateAccountContainer/getRegisterAgreements/then/catch */
            () => {
                this.setState({ isLoadingAgreements: false });

                Promise.reject();
            }
        );
    }

    getRegistrationUrl(customerType) {
        if (this.isInCheckout()) {
            return `${CHECKOUT_CUSTOMER_CREATE_URL}/`;
        }

        switch (customerType) {
        case CUSTOMER_TYPES.pro:
            return ACCOUNT_PRO_REGISTRATION_URL;
        case CUSTOMER_TYPES.student:
            return ACCOUNT_STUDENT_REGISTRATION_URL;
        case CUSTOMER_TYPES.employee:
            return ACCOUNT_EMPLOYEE_REGISTRATION_URL;
        default:
            return ACCOUNT_REGISTRATION_URL;
        }
    }

    goToStep(step, replace = false) {
        const { customerType } = this.state;

        const stepUrl = step !== CUSTOMER_STEP ? step : '';

        const { url: uploadStepUrl = null } = step === UPLOAD_STEP ? { ...this.findNextUploadStep() } : {}; // @TODO not good when history.back...
        const uploadStepUrlPart = uploadStepUrl ? `/${ uploadStepUrl }` : '';

        const path = appendWithStoreCode(`${ this.getRegistrationUrl(customerType) }${ stepUrl }${ uploadStepUrlPart }`);

        if (replace === true) {
            history.replace(path);
        } else {
            history.push(path);
        }
    }

    goToCompanyStep() {
        this.goToStep(COMPANY_STEP);
    }

    onSubmitCompanySearchForm(e, { companyDetails }) {
        this.setState({ companyDetails }, () => this.goToStep(COMPANY_STEP));
    }

    onSubmitCompanyForm(e, { companyDetails }) {
        const {
            customerData: {
                // eslint-disable-next-line no-unused-vars
                siret,
                // eslint-disable-next-line no-unused-vars
                siret_comment,
                ...customerDataWithoutSiret
            }
        } = this.state;

        const newCustomerData = { ...customerDataWithoutSiret, ...companyDetails };

        this.setState({
            companyDetails,
            customerData: newCustomerData
        }, () => this.goToStep(UPLOAD_STEP));
    }

    onSkipConfirmIdForm(e, { file }) {
        const { customerData } = this.state;

        const newCustomerData = { ...customerData, ...file };

        const nextUploadStep = this.findNextUploadStep();

        const nextStep = nextUploadStep ? UPLOAD_STEP : OPTIN_STEP;

        this.setState({
            customerData: newCustomerData
        }, () => this.goToStep(nextStep));
    }

    onSubmitConfirmIdForm(e, { file }) {
        const { customerData } = this.state;

        const newCustomerData = { ...customerData, ...file };

        const nextUploadStep = this.findNextUploadStep();

        const nextStep = nextUploadStep ? UPLOAD_STEP : OPTIN_STEP;

        this.setState({
            customerData: newCustomerData
        }, () => this.goToStep(nextStep));
    }

    onRecapButtonClick() {
        const { onSignIn } = this.props;

        if (this.isInCheckout()) {
            onSignIn();
        } else {
            history.push(appendWithStoreCode('/'));
        }
    }

    /**
     * Save form values into a cookie to retrieve them
     */
    onStoreSwitcherBeforeRedirect() {
        const { current } = this.formRef;

        if (!current) {
            return;
        }

        const fieldValues = getFieldsData(current.formRef, true);

        // eslint-disable-next-line no-unused-vars
        const { password, ...values } = transformToNameValuePair(fieldValues);

        BrowserDatabase.setItem(values, CREATE_ACCOUNT_DATA, CREATE_ACCOUNT_DATA_DURATION);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountCreateAccountContainer);
